import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const postTrialInvestigator = async ({
  trialId,
  first_name,
  last_name,
  email,
  max_patient,
  site_number,
  site_address,
  site_phone,
}) => {
  const token = localStorage.getItem("token");

  const payload = {
    first_name,
    last_name,
    email,
    max_patient,
    site_number,
    site_address,
    site_phone,
  };

  const { data } = await axios.post(
    `${__API_URL__}/api/photos/trial/${trialId}/add_investigator/`,
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return data;
};

const useAddTrialInvestigatorMutation = () => {
  return useMutation({
    mutationFn: postTrialInvestigator,
  });
};

export default useAddTrialInvestigatorMutation;
